import React, { useEffect, useState } from 'react';
import { TextField, Button, Box, Grid, Select, InputLabel, MenuItem } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import DateAdapter from '@material-ui/pickers';
import "./stepper.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepConnector from "@material-ui/core/StepConnector";
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';

import clsx from "clsx";
import PropTypes from 'prop-types';
import Check from '@material-ui/icons/Check';
import { FormControl } from '@material-ui/core';
import { useHistory } from "react-router-dom";
import Niu from '../MainNav'
import PasoUnoForm from './PasoUnoForm'
import PasoDosForm from './PasoDosForm'
import PasoTresForm from './PasoTresForm'
import Comprobante from '../Comprobante'
import UseStyles from './useStyles'
import { useForm } from "react-hook-form";
import { validateForm } from '../commons/utils';
import { singleInputValidator } from '../commons/utils';
import Spinner from '../commons/Spinner/Spinner';
import { getIsapres, getRegion,  getRegionComuna, getGenero, getSexo, getMediadores, postFormulario } from '../commons/api';

import ReactGA from "react-ga";

const useAnalyticsEventTracker = (category="Solicitud de Mediación para controversias con Isapre y Fonasa") => {
  const eventTracker = (action = "Fin de la Solicitud de Mediación para controversias Isapre y Fonasa", label = "Trámite - ID 0300520001") => {
    ReactGA.event({category, action, label});
  }
  return eventTracker;
}




/* define los colores de los iconos segun estado, activo o si aun no llega a ese paso  */
const useQontoStepIconStyles = makeStyles({
  root: {
    color: '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center'
  },

  circle: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },

  active: {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  },
  completed: {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? <Check className={classes.completed} /> : <div className={classes.circle} />}
    </div>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
};

/* metodo para customizar el background color de las lineas entre iconos, en este caso contiene una gradiante */
const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    "& $line": {
      backgroundImage:
        "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
    },
  },
  completed: {
    "& $line": {
      backgroundImage:
        "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
})(StepConnector);

/* metodo para customizar el color de los iconos y su emplazamiento dentro de su contenedor */
const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',

  },
  active: {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  },
  completed: {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
  },
});

/* metodo para customización de los iconos del stepper */
function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  /* aquí se definen los iconos que llevara el stepper */
  const icons = {
    1: <AssignmentTurnedInIcon />,
    2: <AssignmentTurnedInIcon />,
    3: <AssignmentTurnedInIcon />,

  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};




const StepperTemplate = props => {

  const {user} = props
  //console.log("Usuario193:",user)
  const [activeStep, setActiveStep] = useState(0);
  const [hideStepper, setHideStepper] = useState(false)

  /* con el array steps, controlo la cantidad de pasos que tendrá, se puede dejar como '' si no se quiere mostrar */
  const steps = ['Paso 1', 'Paso 2', 'Paso 3']
  const classes = UseStyles();

  const [tituloH1, setTitiloH1] = useState('Guía de Servicios')
  const [titulo, setTitulo] = useState('Solicitud De Mediación Para Controversias Con Isapre Y Fonasa')
  const [nombreRuta, setNombreRuta] = useState('Servicios')
  const [valorButton, setvalorButton] = useState('Siguiente')
  const [spinner, setSpinner] = useState(false)

  const { errors, setError } = useForm();

  const [loaded, setLoaded] = useState(false)
  const [reValid, setReValid] = useState(false)
  const [isapres, setIsapres] = useState([])

  /* variables paso 1 */
  const [rut, setRut] = useState('')
  const [nombre, setNombre] = useState('')
  const [apellidoP, setApellidoP] = useState('')
  const [apellidoM, setApellidoM] = useState('')
  const [region, setRegion] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [nombreComuna, setNombreComuna] = useState([])
  const [direccion, setDireccion] = useState('')
  const [telefono, setTelefono] = useState('')
  const [correo, setCorreo] = useState('')
  const [aseguradora, setAseguradora] = useState('')
  const [nombreRegion, setNombreRegion] = useState([])
  const [comuna, setComuna] = useState("");
  const [nombreProvincia, setNombreProvincia] = useState([])
  const [tipogenero,setTipoGenero]=useState([]);
  const [genero, setGenero] = useState([]);
  const [tiposexo,setTipoSexo]=useState([]);
  const [sexo, setSexo] = useState([]);

  const gaEventTracker = useAnalyticsEventTracker('Solicitud De Mediación Para Controversias Con Isapre Y Fonasa');

  /* variables paso 2 */
  const [rutRep, setRutRep] = useState('')
  const [nombreRep, setNombreRep] = useState('')
  const [apellidoPRep, setApellidoPRep] = useState('')
  const [apellidoMRep, setApellidoMRep] = useState('')
  const [profesionRep, setProfesionRep] = useState('')
  const [direccionRep, setDireccionRep] = useState('')
  const [telefonoRep, setTelefonoRep] = useState('')
  const [correoRep, setCorreoRep] = useState('')

  const [nombreRegionRep, setNombreRegionRep] = useState([])
  const [nombreProvinciaRep, setNombreProvinciaRep] = useState([])
  const [nombreComunaRep, setNombreComunaRep] = useState([])


  const [regionRep, setRegionRep] = useState("");
  const [ciudadRep, setCiudadRep] = useState("");
  const [comunaRep, setComunaRep] = useState("");

  const [show, setShow] = useState(false);
  const [generoRep, setGeneroRep] = useState([]);
  const [sexoRep, setSexoRep] = useState([]);

  /* variables paso 3 */
  const [numIngreso, setNumIngreso] = useState('')
  const [fechaIngreso, setFechaIngreso] = useState('')
  const [mediadorTitular, setMediadorTitular] = useState('')
  const [primerSuplente, setPrimerSuplente] = useState('')
  const [segundoSuplente, setSegundoSuplente] = useState('')
  const [descProblema, setDescProblema] = useState('')
  const [nombreprimerSuplente, setnombreprimerSuplente] = useState('')

  /* comprobante */
  const [folio, setFolio] = useState('nº folio')



  const history = useHistory();

  useEffect(() => {
    setLoaded(true)
    getIsapresApi()
    getGeneroApi()
    getRegionApi()
    getRegionRepApi()
    getSexoApi()
    getMediadoresApi()
  }, [])


  useEffect(() => {
    if(region !== "" ){
      getRegionComunaApi()
    }

    
  }, [region])

  useEffect(() => {
    if(regionRep !== "" ){
      getRegionComunaRepApi()
    }
  }, [regionRep])

  useEffect(() => {

    if (loaded) {
      singleInputValidator(nombre, "Nombre", setError, [])
      singleInputValidator(apellidoP, "apellidoP", setError, [])
      singleInputValidator(apellidoM, "apellidoM", setError, [])
      singleInputValidator(direccion, "direccion", setError, [])
      singleInputValidator(telefono, "telefono", setError, [])
      singleInputValidator(correo, "correo", setError, [])

    }

  }, [reValid])

  useEffect(()=>{
     if(user.rut){
       setRut(user.rut)
     }
    
     if (user.names) {
       setNombre(user.names)
     }
     if (user.last_name){
       setApellidoP(user.last_name)
     }
     if(user.mother_last_name){
       setApellidoM(user.mother_last_name)
     }
     if(user.phone_mobile){
       setTelefono(user.phone_mobile)
     }

     var cadenaCorreo = (user.email)
     var cadenaCorreoLimpio = cadenaCorreo.includes('@temporal.gob.cl')
     //console.log(cadenaCorreo.includes('@temporal.gob.cl'))
     //console.log("aquiiiiiii",cadenaCorreo)
     
    if(!cadenaCorreoLimpio){
      setCorreo(user.email)
    }
     
     /*
     if(user.email){
       setCorreo(user.email)
     }
    */
     
  }, [user] )

  const getIsapresApi = async () => {
  const resp = await getIsapres();
  const resp_status = resp?.status;

  if (resp_status === 200 && Array.isArray(resp.data)) {

    // Convertir id_tipo_aseguradora a número para comparar correctamente
    const isapresFiltradas = resp.data.filter(
      item => Number(item.id_tipo_aseguradora) === 1
    );

    setIsapres(isapresFiltradas);
  }
};

  const getMediadoresApi = async () => {

    const resp = await getMediadores()
    const resp_status = (resp || {}).status;

    if (resp_status === 200) {
      let results = await resp
      let mediadoresAux = []
      results.data.map((item, index) => {
        mediadoresAux.push(item)
        return null
      })
      setnombreprimerSuplente(mediadoresAux)
    }

  }


  const getRegionApi = async () => {

    const resp = await getRegion()
    const resp_status = (resp || {}).status;

    if (resp_status === 200) {
      let results = await resp
      let regionAux = []
      results.data.map((item, index) => {
        regionAux.push(item)
        return null
      })
      setNombreRegion(regionAux)
    }

  }

  const getRegionRepApi = async () => {

    const resp = await getRegion()
    const resp_status = (resp || {}).status;

    if (resp_status === 200) {
      let results = await resp
      let regionAux = []
      results.data.map((item, index) => {
        regionAux.push(item)
        return null
      })
      setNombreRegionRep(regionAux)
    }

  }




  const getGeneroApi = async () => {

    const resp=await getGenero()
    const resp_status = (resp || {}).status;

    if (resp_status === 200) {
      let results = await resp
      let generoAux = []
      results.data.map((item,index)=>{
        generoAux.push(item)
        return null
      })
      setTipoGenero(generoAux)
    }

  }



  const getSexoApi = async () => {

    const resp=await getSexo()
    const resp_status = (resp || {}).status;

    if (resp_status === 200) {
      let results = await resp
      let sexoAux = []
      results.data.map((item,index)=>{
        sexoAux.push(item)
        return null
      })
      setTipoSexo(sexoAux)
    }

  }




  const getRegionComunaApi = async () => {

    const resp = await getRegionComuna(region)
    const resp_status = (resp || {}).status;

    if (resp_status === 200) {
      let results = await resp
      let comunaAux = []
      results.data.comunas.map((comunas, index) => {
        
        //comunas.map((item, indice) => {
          comunaAux.push(comunas)
          //return null 
       // })
        
        return null
      })
      console.log(results.data)
      setNombreComuna(comunaAux)

    }
    
  }


  const getRegionComunaRepApi = async () => {

    const resp = await getRegionComuna(regionRep)
    const resp_status = (resp || {}).status;

    if (resp_status === 200) {
      let results = await resp
      let comunaAux = []
      results.data.comunas.map((comunas, index) => {
        
        //comunas.map((item, indice) => {
          comunaAux.push(comunas)
        //  return null 
        //})
        
        return null
      })
      console.log(results.data)
      setNombreComunaRep(comunaAux)

    }

  }

  /* se toman todos los datos que trae la consulta, pero se usan solo los que son validos en el formulario */
  const setDataFromElastic = (nombres, apellido_p, apellido_m, email, rut) => {
    setRut(rut)
    setNombre(nombres)
    setApellidoP(apellido_p)
    setApellidoM(apellido_m)
    setCorreo(email)
    setReValid(!reValid)

  }

  const getStepContent = (stepIndex) => {
    switch (stepIndex) {
      case 0:
        return (
          <PasoUnoForm
            isapres={isapres}
            nombreRegion={nombreRegion}
            nombreComuna={nombreComuna}
            nombre={nombre}
            setNombre={setNombre}
            rut={rut}
            setRut={setRut}
            apellidoP={apellidoP}
            setApellidoP={setApellidoP}
            apellidoM={apellidoM}
            setApellidoM={setApellidoM}
            genero={genero}
            setGenero={setGenero}
            tipogenero={tipogenero}
            sexo={sexo}
            setSexo={setSexo}
            tiposexo={tiposexo}
            direccion={direccion}
            setDireccion={setDireccion}
            region={region}
            setRegion={setRegion}
            ciudad={ciudad}
            setCiudad={setCiudad}
            nombreProvincia={nombreProvincia}
            comuna={comuna}
            setComuna={setComuna}
            aseguradora={aseguradora}
            setAseguradora={setAseguradora}
            telefono={telefono}
            setTelefono={setTelefono}
            correo={correo}
            setCorreo={setCorreo}
            errors={errors}
            setError={setError}
            setData={setDataFromElastic}
            setSpinner={setSpinner}

          />
        )
      case 1:
        return (
          <PasoDosForm
            nombreRep={nombreRep}
            setNombreRep={setNombreRep}
            rutRep={rutRep}
            setRutRep={setRutRep}
            apellidoPRep={apellidoPRep}
            setApellidoPRep={setApellidoPRep}
            apellidoMRep={apellidoMRep}
            setApellidoMRep={setApellidoMRep}
            profesionRep={profesionRep}
            setProfesionRep={setProfesionRep}
            direccionRep={direccionRep}
            setDireccionRep={setDireccionRep}
            telefonoRep={telefonoRep}
            setTelefonoRep={setTelefonoRep}
            correoRep={correoRep}
            setCorreoRep={setCorreoRep}
            generoRep={generoRep}
            setGeneroRep={setGeneroRep}
            tipogenero={tipogenero}
            sexoRep={sexoRep}
            setSexoRep={setSexoRep}
            tiposexo={tiposexo}
            nombreRegionRep={nombreRegionRep}
            nombreComunaRep={nombreComunaRep}
            nombreProvinciaRep={nombreProvinciaRep}
            regionRep={regionRep}
            setRegionRep={setRegionRep}
            ciudadRep={ciudadRep}
            setCiudadRep={setCiudadRep}
            comunaRep={comunaRep}
            setComunaRep={setComunaRep}

        
            show={show}
            setShow={setShow}
            
            errors={errors}
            setError={setError}
          />
        )
      case 2:
        return (
          <PasoTresForm
            numIngreso={numIngreso}
            setNumIngreso={setNumIngreso}
            fechaIngreso={fechaIngreso}
            setFechaIngreso={setFechaIngreso}
            mediadorTitular={mediadorTitular}
            setMediadorTitular={setMediadorTitular}
            primerSuplente={primerSuplente}
            setPrimerSuplente={setPrimerSuplente}
            segundoSuplente={segundoSuplente}
            setSegundoSuplente={setSegundoSuplente}
            descProblema={descProblema}
            setDescProblema={setDescProblema}
            errors={errors}
            setError={setError}
            nombreprimerSuplente={nombreprimerSuplente}
          />
        )
      default:
        return 'Paso incorrecto';
    }
  }

  const handleNext = () => {
 
    if (activeStep === 0) {

      setvalorButton('Siguiente')

      let auxArr = [
        {
          dato: nombre,
          errName: "Nombre",
          otherValid: []
        },
        {
          dato: rut,
          errName: "Rut",
          otherValid: [{ option: 'rutValidation' }],
        },
        {
          dato: apellidoP,
          errName: "apellidoP",
          otherValid: []
        },
        {
          dato: apellidoM,
          errName: "apellidoM",
          otherValid: []
        },

        {
          dato: genero,
          errName: "genero",
          otherValid: []
        },

        {
          dato: sexo,
          errName: "sexo",
          otherValid: []
        },

        {
          dato: region,
          errName: "region",
          otherValid: []
        },

        {
          dato: comuna,
          errName: "comuna",
          otherValid: []
        },

        {
          dato: direccion,
          errName: "direccion",
          otherValid: []
        },
        {
          dato: correo,
          errName: "correo",
          otherValid: [{ option: 'eMail' }]
        },
        {
          dato: telefono,
          errName: "telefono",
          otherValid: []
        },
        {
          dato: aseguradora,
          errName: "aseguradora",
          otherValid: []
        }]

      if (!validateForm(auxArr, setError)) {
       
        setActiveStep((prevActiveStep) => prevActiveStep + 1)
        
      }
    }

    if (activeStep === 1) {
      setvalorButton('Siguiente')
      let auxArr = [
        
      ]

      if (!show) {
        
        auxArr.push(
          {
            dato: nombreRep,
            errName: "NombreRep",
            otherValid: []
          },
          {
            dato: rutRep,
            errName: "RutRep",
            otherValid: [{ option: 'rutValidation' }],
          },
          {
            dato: apellidoPRep,
            errName: "apellidoPRep",
            otherValid: []
          },
        
    
          {
            dato: direccionRep,
            errName: "direccionRep",
            otherValid: []
          },
          
          {
            dato: generoRep,
            errName: "generoRep",
            otherValid: []
          },
  
          {
            dato: sexoRep,
            errName: "sexoRep",
            otherValid: []
          },

          {
            dato: correoRep,
            errName: "correoRep",
            otherValid: [{ option: 'eMail' }]
          },
          {
            dato: telefonoRep,
            errName: "telefonoRep",
            otherValid: []
          })

          console.log(auxArr)

      }
     
      if (!validateForm(auxArr, setError)) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1)
        setvalorButton('Enviar')
      }
    }


    if (activeStep === 2) {
      
      setvalorButton('Enviar')

      let auxArr = [
        {
          dato: mediadorTitular,
          errName: "mediadorTitular",
          otherValid: []
        },
        {
          dato: primerSuplente,
          errName: "primerSuplente",
          otherValid: []
        },
        {
          dato: segundoSuplente,
          errName: "segundoSuplente",
          otherValid: []
        }
      ]

      if (!validateForm(auxArr, setError)) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1)
        handleEnviar()
        

      }
    }




  };

  const handleBack = () => {

    setActiveStep((prevActiveStep) => prevActiveStep - 1)
    setvalorButton('Siguiente')

  };

  const handleNavClick = () => {
    console.log('poner aqui la navegacion')

  }

  const handleEnviar = async () => {

    let auxRut = rut.replace(/\./g, "");
    let auxRut2= rutRep.replace(/\./g, "");
   
    gaEventTracker('Fin de la Solicitud de Mediación para controversias Isapre y Fonasa')
    
    if (auxRut2 === '' ) {
        const rut_rep_aux = auxRut       
        let nombres_rep_aux= nombre      
        let apellido_pat_rep_aux= apellidoP     
        let apellido_mat_rep_aux= apellidoM      
        let sexo_id_rep_aux= sexo       
        let genero_id_rep_aux= genero     
        let region_id_rep_aux= region      
        let comuna_id_rep_aux= comuna      
        let direccion_nombre_rep_aux= direccion        
        let telefono_rep_aux=telefono        
        let correo_rep_aux = correo  
        
        let auxArr = 
      {
        
        tipo_tramitacion: 'mediacion_if',  
        rut: auxRut,  
        nombres: nombre,
        apellido_pat: apellidoP,
        apellido_mat: apellidoM,
        sexo_id: sexo,
        genero_id: genero,
        region_id: region,
        comuna_id: comuna,
        direccion_nombre: direccion,
        telefono: telefono,
        correo: correo,
        tipo_rep: true,
        rut_rep: rut_rep_aux,       
        nombres_rep: nombres_rep_aux,        
        apellido_pat_rep: apellido_pat_rep_aux,      
        apellido_mat_rep: apellido_mat_rep_aux,       
        sexo_id_rep: sexo_id_rep_aux,       
        genero_id_rep: genero_id_rep_aux,       
        region_id_rep: region_id_rep_aux,       
        comuna_id_rep: comuna_id_rep_aux,       
        direccion_nombre_rep: direccion_nombre_rep_aux,        
        telefono_rep: telefono_rep_aux,        
        correo_rep: correo_rep_aux,       
        aseguradora_id: aseguradora,        
        desc_problema: descProblema,
        mediador_id: mediadorTitular,      
        mediadors1_id: primerSuplente,
        mediadors2_id: segundoSuplente
      }

    let tempFolio = await postFormulario(auxArr)
    setFolio(tempFolio)
    setTitulo('Comprobante')
    setHideStepper(true)
    ReactGA.event('Fin de la Solicitud de Mediación para controversias Isapre y Fonasa');
    
    

      
    }else{
        const rut_rep_aux = auxRut2       
        let nombres_rep_aux= nombreRep       
        let apellido_pat_rep_aux= apellidoPRep      
        let apellido_mat_rep_aux= apellidoMRep      
        let sexo_id_rep_aux= sexoRep       
        let genero_id_rep_aux= generoRep      
        let region_id_rep_aux= regionRep      
        let comuna_id_rep_aux= comunaRep      
        let direccion_nombre_rep_aux= direccionRep        
        let telefono_rep_aux=telefonoRep        
        let correo_rep_aux = correoRep

        let auxArr = 
        {
          rut: auxRut,
          tipo_tramitacion: 'mediacion_if',  
          nombres: nombre,
          apellido_pat: apellidoP,
          apellido_mat: apellidoM,
          sexo_id: sexo,
          genero_id: genero,
          region_id: region,
          comuna_id: comuna,
          direccion_nombre: direccion,
          telefono: telefono,
          correo: correo,
          tipo_rep: false,
          rut_rep: rut_rep_aux,       
          nombres_rep: nombres_rep_aux,        
          apellido_pat_rep: apellido_pat_rep_aux,      
          apellido_mat_rep: apellido_mat_rep_aux,       
          sexo_id_rep: sexo_id_rep_aux,       
          genero_id_rep: genero_id_rep_aux,       
          region_id_rep: region_id_rep_aux,       
          comuna_id_rep: comuna_id_rep_aux,       
          direccion_nombre_rep: direccion_nombre_rep_aux,        
          telefono_rep: telefono_rep_aux,        
          correo_rep: correo_rep_aux,       
          aseguradora_id: aseguradora,        
          desc_problema: descProblema,
          mediador_id: mediadorTitular,      
          mediadors1_id: primerSuplente,
          mediadors2_id: segundoSuplente


        }

      let tempFolio = await postFormulario(auxArr)
      setFolio(tempFolio)
      setTitulo('Comprobante')
      setHideStepper(true)
    
      
  

    }


      
   // if (!validateForm(auxArr, setError)) {
      //console.log("aqui enviando")
    
    ///}

  };


  return (

    <>
      <Spinner show={spinner} />
      {/* el componente de navegacion */}
      <Niu titulo={tituloH1} nombreRuta={nombreRuta} handleNavClick={handleNavClick}></Niu>

      {/* el contenedor del formulario */}
      <div className={classes.contenedorForm + ' shadow'}  >

        <div hidden={hideStepper}>
          <h2 style={{ fontSize: 26 }} className="py-2">{titulo}</h2>

        </div>
        <div className={classes.root}>

          <Stepper hidden={hideStepper} activeStep={activeStep} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel >{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          {/* hay que ocultar el div donde esta el getStepContent para mostrar el comprobante en su lugar */}
          <div hidden={!hideStepper}>
            <Comprobante
              folio={folio}
              nombreSolicitante={nombre + ' ' + apellidoP + ' ' + apellidoM}
            />
          </div>
          <div hidden={hideStepper}>
            {/*  acá se cargan las vistas de los elementos de formulario segun el paso en el que se esté, sería conveniente 
            crear componentes para cada paso */}
            {getStepContent(activeStep)}

            {/* aquí se pueden modificar los botones para avanzar o retroceder, dependiendo del valor del active step se pueden 
            hacer varias cosas curiosas */
            }
            <Box display="flex" justifyContent="space-between">

              <Grid style={{ marginLeft: 40, marginBottom: 20, paddingTop: 10 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleBack}
                  hidden={activeStep === 0}
                >
                  Atrás
                </Button>
              </Grid>

              <Grid style={{ marginRight: 40, marginBottom: 20, paddingTop: 10 }}>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleNext}
                  hidden={activeStep === steps.length - 0}
                >
                  {valorButton}
                </Button>
                
              </Grid>

            </Box>
          </div>

        </div>
        <div>

        </div>
      </div>

    </>

  );
}
export default StepperTemplate;
